import { api } from '@/api/client';

export type UserSatisfactionPayload = {
  nota: number;
  comentario?: string;
};

export async function submitUserSatisfaction(payload: UserSatisfactionPayload): Promise<void> {
  await api.post('/v3/usuario/pesquisa/satisfacao', payload);
}
